import React from 'react';
import { Switch, Route } from 'react-router-dom';
// Screens
import LiveWebinarLayout from './LiveWebinarLayout';

const LiveWebinarStack = () => {
  return (
    <Switch>
      <Route exact path="/live-doubt-class" component={LiveWebinarLayout} />
    </Switch>
  );
};
export default LiveWebinarStack;
